export default function genererSurface() {
  return {
    libelle: '',
    code: '',
    ratio: 0,
  };
}
